import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchemaV2NestedShapeValues,
  SHOW_DIVIDER_LINE_KEY,
  StepConfigEditorOverride,
} from '../../StepConfigEditorTypes';

/**
 * Pie Chart configuration sections for the Configure tab
 */
export const PIE_CHART_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['nameSection', 'sliceSection', 'measureSection'],
  nameSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['chartName'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    chartName: {
      displayName: 'Title',
      configShapePath: ['chartName'],
    },
  },
  sliceSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['sliceColumnName'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    sliceColumnName: {
      displayName: 'Slice',
      configShapePath: ['chartConfig', 'parameters', 'sliceColumnName'],
    },
  },
  measureSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['measureColumnName'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    measureColumnName: {
      displayName: 'Measure',
      configShapePath: ['chartConfig', 'parameters', 'measureColumnName'],
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;

/**
 * Pie Chart style sections for the Style tab
 */
export const PIE_CHART_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection', 'sliceLabelSection'],
  legendSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Legend',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['showLegend', 'position', 'customLabel'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    showLegend: {
      configShapePath: ['chartConfig', 'parameters', 'showLegend'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show legend',
        defaultValue: true,
      },
    },
    position: {
      displayName: 'Position',
      configShapePath: ['chartConfig', 'parameters', 'legendLocation'],
      fieldSettings: {
        displayNames: {
          TOP: 'Top',
          LEFT: 'Left',
          RIGHT: 'Right',
        },
      },
    },
    customLabel: {
      displayName: 'Custom label (optional)',
      configShapePath: ['chartConfig', 'parameters', 'legendLabel'],
    },
  },
  sliceLabelSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Slice labels',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['showSliceNameInLabel', 'showPercentageInLabel', 'showValueInLabel'],
    showSliceNameInLabel: {
      configShapePath: ['chartConfig', 'parameters', 'showSliceNameInLabel'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show slice name',
      },
    },
    showPercentageInLabel: {
      configShapePath: ['chartConfig', 'parameters', 'showPercentageInLabel'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show percentage',
      },
    },
    showValueInLabel: {
      configShapePath: ['chartConfig', 'parameters', 'showValueInLabel'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show value',
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;
